import { faCat, faDog, faTurtle } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { PetType, PetTypeIds } from '@spike/model';
import clsx from 'clsx';
import isEmpty from 'lodash/isEmpty';
import { FunctionComponent } from 'react';
import styles from './PetAvatar.module.scss';

interface PetAvatarProps {
    petType?: PetType;
    imageUrl?: string;
    className?: string;
    iconClassName?: string;
}

export const PetAvatar: FunctionComponent<PetAvatarProps> = props => {
    return (
        <div className={clsx(styles.container, props.className)}>
            {!isEmpty(props.imageUrl) ? (
                <div
                    className={styles.image}
                    style={{ backgroundImage: `url(${props.imageUrl})` }}
                />
            ) : (
                <div
                    className={clsx(
                        styles.emptyImage,
                        { [styles.dog]: props.petType?.id === PetTypeIds.DOGS },
                        { [styles.cat]: props.petType?.id === PetTypeIds.CATS }
                    )}
                >
                    <FontAwesomeIcon
                        icon={
                            props.petType?.id === PetTypeIds.CATS
                                ? faCat
                                : props.petType?.id === PetTypeIds.DOGS
                                ? faDog
                                : faTurtle
                        }
                        className={clsx(
                            styles.icon,
                            { [styles.dogIcon]: props.petType?.id === PetTypeIds.DOGS },
                            { [styles.catIcon]: props.petType?.id === PetTypeIds.CATS },
                            props.iconClassName
                        )}
                    />
                </div>
            )}
        </div>
    );
};

export default PetAvatar;
